import {
  Body,
  Button,
  Caption,
  Glide,
  Image,
  Row,
  Shape,
  SubTitle,
  styled,
} from '@teko/ds-desktop';
import { ProductCarousel } from '@teko/teko-ecommerce';
import { useTenantConfig } from 'contexts';
import { isServerless } from 'helpers';
import { t } from 'i18n';
import { useRouter } from 'next/router';
import { useProductRecipes } from '../../hooks/useProductRecipes';

export const ProductRecipes = () => {
  const { displayNewLayout } = useTenantConfig();
  const router = useRouter();
  const {
    selectedRecipe,
    setSelectedRecipe,
    orderedMaterials,
    cookingRecipes,
  } = useProductRecipes();

  return cookingRecipes.length ? (
    <Shape padding={['s8', 's0']} marginTop="s8" backgroundColor="white">
      <StyledContent>
        <StyledHeaderContent>
          <SubTitle level={2}>{t('Khám phá món ngon')}</SubTitle>
        </StyledHeaderContent>

        <Shape padding="s8">
          <Glide
            perView={isServerless() && window.innerWidth <= 1440 ? 5.5 : 7}
            showControl={false}
            style={{ height: '136px' }}
          >
            {cookingRecipes.map((recipe, index) => (
              <DishCard
                key={index}
                className={recipe.id === selectedRecipe?.id ? 'selected' : ''}
                onClick={() => {
                  setSelectedRecipe(recipe);
                }}
              >
                <Image
                  className="dish-image"
                  src={recipe.images?.[0]?.url || ''}
                />
                <Caption className="dish-name" level={1} line={2}>
                  {recipe.title}
                </Caption>
              </DishCard>
            ))}
          </Glide>
          <Shape
            backgroundColor="#F5F5F5"
            width="100%"
            borderRadius="m"
            padding="s8"
          >
            {!!selectedRecipe?.description && (
              <Row marginBottom="s8">
                <DescriptionRecipe level={1}>
                  {selectedRecipe?.description}
                </DescriptionRecipe>
              </Row>
            )}
            <Row align="middle" justify="space-between" marginBottom="s8">
              <SubTitle level={2}>{t('Nguyên liệu')}</SubTitle>
              <ViewRecipeButton
                variant="primary"
                className="btn"
                height="2rem"
                onClick={() => {
                  router.push(selectedRecipe?.url || '/');
                }}
              >
                {t('Xem công thức')}
              </ViewRecipeButton>
            </Row>
            {!!orderedMaterials?.length ? (
              <StyledProductCarousel
                products={orderedMaterials}
                productsPerRow={4}
                regionName="productRecipes"
                desktopProps={{
                  perSwipe: '',
                  bound: true,
                  displayNewLayout,
                }}
              />
            ) : null}
          </Shape>
        </Shape>
      </StyledContent>
    </Shape>
  ) : null;
};

const StyledContent = styled.div`
  border: 1px groove;
  border-radius: 16px;
`;

const StyledHeaderContent = styled.div`
  padding: 8px;
  background-color: #f5f5f5;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  display: flex;
  align-items: center;
`;

const DishCard = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  overflow: visible;
  border-radius: 16px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  .dish-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 16px;
  }
  .dish-name {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 4px 6px;
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
    text-align: left;
    width: 100%;
    height: 48px;
    border-radius: 12px;
    line-height: 21px;
  }
  // style for selected dish (recipe)
  &.selected {
    border: 1.5px solid #0200bc;
    &:after {
      content: '';
      position: absolute;
      bottom: -24;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 16px solid transparent;
      border-right: 16px solid transparent;
      border-bottom: 24px solid #f5f5f5;
    }
  }
`;

const ViewRecipeButton = styled(Button)`
  border-radius: 1000px;
  flex: 0 0 auto; /* không co kéo để giữ kích thước nội dung */
  white-space: nowrap;
  cursor: pointer;
`;

const DescriptionRecipe = styled(Body)`
  flex: 1 1 auto;
`;

const StyledProductCarousel = styled(ProductCarousel)`
  .horizontal-slider,
  .glide__track {
    border-radius: 12px !important;
    max-width: 100%;
  }
  .glide__arrow--override {
    width: 40px !important;
    height: 40px !important;
  }
  .glide__arrow--left {
    left: -6px !important;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
    &:after {
      height: 24px !important;
      width: 24px !important;
    }
  }
  .glide__arrow--right {
    right: -6px !important;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
    &:after {
      height: 24px !important;
      width: 24px !important;
    }
  }
  .glide__slides {
    margin: 0;
  }
`;
